import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Loader2, Mail, MailOpen } from "lucide-react";

export default function AdminChats() {
  const [chats, setChats] = useState(null);

  const load = () => api.get("/admin/chats").then((r) => setChats(r.data)).catch(() => setChats([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/chats/${id}/status?status=${status}`); load(); }
    catch { toast.error("Update failed"); }
  };

  if (chats === null) return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" style={{ color: "#B08D57" }} /></div>;

  return (
    <div data-testid="admin-chats">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading text-2xl">Concierge Inbox</h2>
        <span className="text-xs" style={{ color: "#6B7280" }}>{chats.filter((c) => c.status === "new").length} new · reply from your own email</span>
      </div>
      {chats.length === 0 ? (
        <div className="rounded-2xl border p-10 text-center bg-white" style={{ borderColor: "#E5E7EB", color: "#6B7280" }}>No messages yet.</div>
      ) : (
        <div className="space-y-4">
          {chats.map((c) => (
            <div key={c.chat_id} data-testid={`admin-chat-${c.chat_id}`}
              className="rounded-2xl border p-5 bg-white" style={{ borderColor: c.status === "new" ? "#B08D57" : "#E5E7EB" }}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <p className="font-medium">{c.name}</p>
                    <a href={`mailto:${c.email}?subject=Re: Your Rokert Retreats enquiry`} className="text-sm underline" style={{ color: "#B08D57" }}>{c.email}</a>
                    {c.status === "new" && <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full" style={{ background: "#B08D57", color: "#fff" }}>New</span>}
                    {!c.emailed && <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full" style={{ background: "#FBE3E4", color: "#B23A48" }}>Email off</span>}
                  </div>
                  <p className="text-sm mt-2 whitespace-pre-wrap" style={{ color: "#374151" }}>{c.message}</p>
                  {(c.phone || c.country) && <p className="text-xs mt-2" style={{ color: "#6B7280" }}>{[c.phone, c.country].filter(Boolean).join(" · ")}</p>}
                  <p className="text-xs mt-2" style={{ color: "#9CA3AF" }}>{new Date(c.created_at).toLocaleString()}</p>
                </div>
                <div className="flex flex-col gap-2 shrink-0">
                  <a href={`mailto:${c.email}?subject=Re: Your Rokert Retreats enquiry`} onClick={() => setStatus(c.chat_id, "replied")} data-testid={`chat-reply-${c.chat_id}`}
                    className="text-xs px-3 py-2 rounded-lg text-white flex items-center gap-1.5" style={{ background: "#111111" }}><Mail className="w-3.5 h-3.5" /> Reply</a>
                  <button onClick={() => setStatus(c.chat_id, c.status === "read" ? "new" : "read")} data-testid={`chat-read-${c.chat_id}`}
                    className="text-xs px-3 py-2 rounded-lg border flex items-center gap-1.5" style={{ borderColor: "#E5E7EB", color: "#374151" }}><MailOpen className="w-3.5 h-3.5" /> {c.status === "read" ? "Unread" : "Read"}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
